import React, { useState, useEffect } from "react";

import IntlMessages from "../../../../../util/IntlMessages";
/**
 * TypingIndicator is a React functional component that displays an animation indicating that someone is typing.
 *
 * The component shows a message "Assistant is typing..." followed by a series of dots that animate to simulate typing. but you can condition intl.messages if needed
 *
 * The animation starts after an initial delay of 500 milliseconds. Once it starts, the dots cycle every 500 milliseconds
 * through a sequence of 0 to 3 dots.
 *
 * @component
 * @example
 * return (
 *   <TypingIndicator />
 * );
 */
const TypingIndicator: React.FC = () => {
   const [dots, setDots] = useState<string>("");
   const [showDots, setShowDots] = useState<boolean>(false);

   useEffect(() => {
      const startDots = () => setShowDots(true);

      const delayTimeout = setTimeout(startDots, 500);

      return () => clearTimeout(delayTimeout);
   }, []);

   useEffect(() => {
      if (showDots) {
         const updateDots = () => {
            setDots((prevDots) => (prevDots.length >= 3 ? "" : prevDots + "."));
         };

         const interval = setInterval(updateDots, 500);

         return () => clearInterval(interval);
      }
   }, [showDots]);

   return (
      <div className="typing-indicator">
         <IntlMessages id="chat.assistent.typing" />
         {dots}
      </div>
   );
};

export default TypingIndicator;
